export const customerNameRegex = /^(\w*)\s(.\w*)*$/

export const shippingNameRegex = /^(?=.*[A-Za-z0-9])/

export const shippingNameStartingLetterRegex = /^[\D]/

export const poBoxRegex = /\bP(ost|ostal)?([ \.]*(O|0)(ffice)?)?([ \.]*Box)\b/i

export const noSurroundingWhitespaceRegex = /^[-a-zA-Z0-9]+(\s+[-a-zA-Z0-9]+)*/

export const carrierMessageRegex = /^[a-zA-Z0-9-!?''\u2018\u2019,. \n]+$/
export const embossRegex = /[^-a-zA-Z0-9-!?',. \s]/

//allows for apostrophes, hyphens, numbers, and periods
export const specialTestRegex = /^[a-zA-Z-'. ]+$/

//allows for spaces, hypens, periods, and alphanumeric chars
export const addressLineRegex = /^[a-zA-Z0-9. -]+$/
